import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { installations } from '../reducers/installations';
import * as actions from '../actions/installations';
import ImportPreview from '../components/InstallationsImportPreview';

const store = createStore(installations);

const element = document.getElementById('importPreview');

if (element) {
    const headers = JSON.parse(element.getAttribute('data-headers'));
    const rows = JSON.parse(element.getAttribute('data-rows'));

    store.dispatch(actions.setInstallationsHeaders(headers));
    store.dispatch(actions.setInstallationsRows(rows));

    const cancelUrl = element.getAttribute('data-cancel-url');
    const submitUrl = element.getAttribute('data-submit-url');
    const successUrl = element.getAttribute('data-success-url');

    ReactDOM.render(
        <Provider store={ store }>
            <ImportPreview
                cancelUrl={ cancelUrl }
                submitUrl={ submitUrl }
                successUrl={ successUrl }
            />
        </Provider>,
        element,
    );
}

